(function () {
  // The asset can be encountered again when the Theme Editor replaces a section.
  if (window.axisModelViewerController) {
    window.axisModelViewerController.initAll(document);
    return;
  }
  var instances = new Map();
  function initAxisModelViewer(root) {
    if (!root || instances.has(root)) return;

    var viewer = root.querySelector('[data-axis-model-viewer-viewer]');
    var toggle = root.querySelector('[data-axis-model-viewer-toggle]');
    var gesture = root.querySelector('[data-axis-model-viewer-gesture]');
    if (!viewer) return;
    var controller = new AbortController();
    var disposed = false;
    var gestureTimeout = 0;
    function listen(target, name, callback, options) {
      target.addEventListener(name, callback, Object.assign({}, options, { signal: controller.signal }));
    }
    function destroy() {
      disposed = true;
      controller.abort();
      stopPlaybackControllers();
      window.clearTimeout(gestureTimeout);
      if (viewer.pause) viewer.pause();
      instances.delete(root);
      delete root.dataset.axisModelViewerReady;
    }
    instances.set(root, destroy);
    root.dataset.axisModelViewerReady = '1';

    var openSrc = viewer.dataset.openSrc || '';
    var closeSrc = viewer.dataset.closeSrc || '';
    var closedSrc = viewer.dataset.closedSrc || closeSrc;
    var cameraTarget = viewer.dataset.cameraTarget || viewer.getAttribute('camera-target') || '';
    var defaultOrbit = viewer.dataset.cameraOrbit || viewer.getAttribute('camera-orbit') || '';
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var state = 'open';
    var activeSrc = viewer.getAttribute('src') || openSrc;
    var closeMonitor = 0;
    var closeTimeout = 0;
    var lastCloseTime = 0;
    var clipStart = 1 / 24;
    var clipEndPadding = 1 / 60;

    function hideGesture() {
      if (disposed) return;
      if (gesture) gesture.classList.add('is-hidden');
    }

    function setButton(label, disabled) {
      if (!toggle) return;
      toggle.textContent = label;
      toggle.disabled = !!disabled;
    }

    function stopPlaybackControllers() {
      if (closeMonitor) {
        window.cancelAnimationFrame(closeMonitor);
        closeMonitor = 0;
      }
      if (closeTimeout) {
        window.clearTimeout(closeTimeout);
        closeTimeout = 0;
      }
    }

    function duration() {
      var value = Number(viewer.duration || 0);
      return Number.isFinite(value) ? value : 0;
    }

    function currentOrbit() {
      if (!viewer.getCameraOrbit) return defaultOrbit;

      var orbit = viewer.getCameraOrbit();
      return orbit.theta.toString() + ' ' + orbit.phi.toString() + ' ' + orbit.radius.toString();
    }

    function applyView(orbit) {
      if (cameraTarget) viewer.setAttribute('camera-target', cameraTarget);
      if (orbit || defaultOrbit) viewer.setAttribute('camera-orbit', orbit || defaultOrbit);
      if (viewer.jumpCameraToGoal) viewer.jumpCameraToGoal();
    }

    function loadSrc(nextSrc, onLoad) {
      if (disposed) return;
      if (!nextSrc) {
        if (onLoad) onLoad();
        return;
      }

      if (activeSrc === nextSrc) {
        if (onLoad) onLoad();
        return;
      }

      activeSrc = nextSrc;
      if (onLoad) {
        listen(viewer, 'load', function handleLoad() {
          onLoad();
        }, { once: true });
      }
      viewer.src = nextSrc;
    }

    function finalizeClosedState() {
      if (disposed) return;
      stopPlaybackControllers();
      if (viewer.pause) viewer.pause();

      try {
        var total = duration();
        if (total > 0) viewer.currentTime = Math.max(total - clipEndPadding, clipStart);
      } catch (error) {
        // Ignore timing writes before model-viewer animation metadata is ready.
      }

      state = 'closed';
      setButton('Reset Model', false);
    }

    function monitorClosePlayback() {
      if (disposed || state !== 'closing') {
        stopPlaybackControllers();
        return;
      }

      var total = duration();
      var current = Number(viewer.currentTime || 0);
      if (total > 0 && (current >= total - 0.05 || current + 0.08 < lastCloseTime)) {
        finalizeClosedState();
        return;
      }

      lastCloseTime = current;
      closeMonitor = window.requestAnimationFrame(monitorClosePlayback);
    }

    function resetOpen() {
      var orbit = currentOrbit();
      state = 'opening';
      setButton('Resetting...', true);
      stopPlaybackControllers();

      loadSrc(openSrc, function () {
        if (viewer.pause) viewer.pause();
        applyView(orbit);
        state = 'open';
        setButton('Close Lid', false);
      });
    }

    function closeWithoutMotion() {
      if (disposed) return;
      var orbit = currentOrbit();
      state = 'closing';
      setButton('Closing...', true);

      loadSrc(closedSrc, function () {
        if (viewer.pause) viewer.pause();
        applyView(orbit);
        state = 'closed';
        setButton('Reset Model', false);
      });
    }

    function closeWithMotion() {
      if (reduceMotion) {
        closeWithoutMotion();
        return;
      }

      var orbit = currentOrbit();
      state = 'closing';
      setButton('Closing...', true);
      loadSrc(closeSrc, function () {
        applyView(orbit);
        try {
          viewer.animationName = 'LidClose';
          viewer.currentTime = clipStart;
        } catch (error) {
          closeWithoutMotion();
          return;
        }

        lastCloseTime = clipStart;
        stopPlaybackControllers();

        var playResult = viewer.play && viewer.play({ repetitions: 1 });
        var timeoutMs = Math.max(2600, Math.round((duration() + 0.08) * 1000));
        closeTimeout = window.setTimeout(function () {
          if (state === 'closing') finalizeClosedState();
        }, timeoutMs);
        closeMonitor = window.requestAnimationFrame(monitorClosePlayback);

        if (playResult && playResult.catch) {
          playResult.catch(function () {
            closeWithoutMotion();
          });
        }
      });
    }

    if (toggle) {
      listen(toggle, 'click', function () {
        hideGesture();
        if (state === 'open') {
          closeWithMotion();
          return;
        }
        if (state === 'closed') resetOpen();
      });
    }

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (eventName) {
      listen(viewer, eventName, hideGesture, { once: true, passive: true });
    });

    if (reduceMotion) {
      hideGesture();
    } else {
      gestureTimeout = window.setTimeout(hideGesture, 7600);
    }

    listen(viewer, 'finished', function () {
      if (state === 'closing') finalizeClosedState();
    });

    listen(viewer, 'load', function () {
      applyView(defaultOrbit);
    }, { once: true });
  }

  function initAll(container) {
    container = container || document;
    if (container.matches && container.matches('[data-axis-model-viewer]')) initAxisModelViewer(container);
    container.querySelectorAll('[data-axis-model-viewer]').forEach(initAxisModelViewer);
  }

  window.axisModelViewerController = { initAll: initAll };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, root) {
      if (event.target === root || event.target.contains(root)) destroy();
    });
  });
})();
